export default __webpack_public_path__ + "static/media/feature-1-trackers.684aeefb.svg";